import { Link } from "react-router-dom";
import { BookOpen, Lock, LayoutDashboard, LogOut, Brain, Printer, Trophy } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const SiteHeader = () => {
  const { user, logout } = useAuth();
  return (
    <header className="sticky top-0 z-40 border-b-[2.5px] border-[var(--ink)] bg-[var(--paper)]/90 backdrop-blur-md print:hidden">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-2 px-3 py-3 sm:px-8">
        <Link to="/" aria-label="Paroloteca - Home" className="flex items-center gap-3" data-testid="header-logo-link">
          <span className="ink-box-sm flex h-10 w-10 items-center justify-center rounded-xl bg-[var(--sun)]">
            <BookOpen className="h-5 w-5" strokeWidth={2.5} />
          </span>
          <span className="hidden leading-none min-[420px]:block">
            <span className="font-display block text-lg font-bold">Paroloteca</span>
            <span className="text-[11px] font-bold uppercase tracking-widest text-neutral-600">Glossario di terza media</span>
          </span>
        </Link>
        <div className="flex items-center gap-1.5 sm:gap-2">
          <Link to="/quiz" aria-label="Quiz" data-testid="header-quiz-link" className="ink-box-sm ink-press flex items-center gap-2 rounded-full bg-[var(--sun)] p-2 text-sm font-bold sm:px-4">
            <Brain className="h-4 w-4" /> <span className="hidden sm:inline">Quiz</span>
          </Link>
          <Link to="/classifica" aria-label="Classifica" data-testid="header-leaderboard-link" className="ink-box-sm ink-press flex items-center gap-2 rounded-full bg-white p-2 text-sm font-bold sm:px-4">
            <Trophy className="h-4 w-4" /> <span className="hidden sm:inline">Classifica</span>
          </Link>
          <Link to="/stampa" aria-label="Stampa PDF" data-testid="header-print-link" className="ink-box-sm ink-press flex items-center gap-2 rounded-full bg-white p-2 text-sm font-bold sm:px-4">
            <Printer className="h-4 w-4" /> <span className="hidden sm:inline">PDF</span>
          </Link>
        {user ? (
          <div className="flex items-center gap-1.5 sm:gap-2">
            <Link to="/docente" aria-label="Area docente" data-testid="header-dashboard-link" className="ink-box-sm ink-press flex items-center gap-2 rounded-full bg-white p-2 text-sm font-bold sm:px-4">
              <LayoutDashboard className="h-4 w-4" /> <span className="hidden sm:inline">Area docente</span>
            </Link>
            <button onClick={logout} data-testid="header-logout-button" className="ink-box-sm ink-press rounded-full bg-[var(--coral)] p-2 text-white" aria-label="Esci">
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        ) : (
          <Link to="/docente/login" aria-label="Area docente" data-testid="header-teacher-login-link" className="ink-box-sm ink-press flex items-center gap-2 rounded-full bg-white p-2 text-sm font-bold sm:px-4">
            <Lock className="h-4 w-4" /> <span className="hidden sm:inline">Area docente</span>
          </Link>
        )}
        </div>
      </div>
    </header>
  );
};
